import { IonRouterOutlet } from '@ionic/react';
import { useEffect } from 'react';

import { SelectDentist } from '@/pages/profiles';
import { ROUTES } from '@/utils/routes';
import { Redirect, Route } from 'react-router-dom';

interface ProfilesProps {}

const Profiles: React.FC<ProfilesProps> = () => (
  <IonRouterOutlet animated={false}>
    {/* Profiles Routes */}
    <Route exact path={ROUTES.ROOT}>
      <SelectDentist />
    </Route>

    {/* Redirect non-profiles routes to root */}
    <Route>
      <Redirect to={ROUTES.ROOT} />
    </Route>
  </IonRouterOutlet>
);

export default Profiles;
